import React from 'react';

const OrderSummary = ({ program, fullAmount }) => (
  <div className="network-card p-8" data-testid="checkout-order-summary">
    <h2 className="text-2xl font-bold text-white mb-4">Order Summary</h2>
    <div className="space-y-4">
      <div>
        <p className="text-text-secondary text-sm">Program</p>
        <p
          className="text-white font-semibold text-lg"
          data-testid="checkout-program-name"
        >
          {program.name}
        </p>
      </div>

      <div>
        <p className="text-text-secondary text-sm">Duration</p>
        <p className="text-white">{program.duration}</p>
      </div>

      <div className="border-t border-white/10 pt-4 mt-4">
        <p className="text-text-secondary text-sm mb-2">Total Amount</p>
        <p
          className="text-brand-accent text-3xl font-bold"
          style={{ textShadow: '0 0 20px rgba(255, 215, 0, 0.5)' }}
          data-testid="checkout-total-amount"
        >
          ₹{fullAmount.toLocaleString('en-IN')}
        </p>
      </div>
    </div>
  </div>
);

export default OrderSummary;
